import { createReducer } from 'reduxsauce';
import { cloneDeep, isEqual, filter } from 'lodash';

import { HumanResourcesTypes } from '../actions/humanresources.actions';

const initialState = {
  status: [],
  users: [],
  userInfractions: null,
  individualUserActivity: null,
  userStats: null,
  createdUser: null,
  disabledUser: null,
  activatedUser: null,
  overallUserActivity: null,
  overallUserActivityList: [],
  taskHistory: null,
  userActivityStats: null,
  commissionHistory: null,
  userActivityTypes: null,
  usersByBranch: null,
  employeeFileList: [],
  userLimitModal: false,
};

const createUserSuccess = (state, action) => {
  const users = cloneDeep(state.users);
  users.push(action.response);
  users.sort((a, b) => {
    const aName = a.firstName.toLowerCase();
    const bName = b.firstName.toLowerCase();
    if (aName < bName) {
      return -1;
    }
    if (aName > bName) {
      return 1;
    }
    return 0;
  });

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-createuser', a));

  return {
    ...state,
    users,
    createdUser: action.response,
    status,
  };
};
const createUserFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-createuser', a));

  return { ...state, status };
};

const getAllUserStatsSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-all-users-request', a));

  return { ...state, userStats: action.response, status };
};
const getAllUserStatsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-all-users-request', a));

  return { ...state, status };
};

const getUsersRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pendig-get-users');

  return { ...state, status };
};
const getUsersSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pendig-get-users', a));
  status.push('success-get-users');

  return { ...state, users: action.response, status };
};
const getUsersFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pendig-get-users', a));

  return { ...state, status };
};
const clearSuccessUsersRequest = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('success-get-users', a));

  return { ...state, status };
};

const getUsersInfractionsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-users-infractions-request');

  return { ...state, status };
};

const getUsersInfractionsSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-infractions-request', a));

  return { ...state, userInfractions: action.response, status };
};

const getUsersInfractionsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-infractions-request', a));

  return { ...state, status };
};

const getUsersActivitiesRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-get-users-activities-request-${action.userId}`);

  return { ...state, status };
};

const getUsersActivitiesSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-activities-request', a));

  return { ...state, individualUserActivity: action.response, status };
};

const getUsersActivitiesFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-activities-request', a));

  return { ...state, status };
};

const getUsersTaskHistoryRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-users-task-history-request');

  return { ...state, status };
};

const getUsersTaskHistorySuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-task-history-request', a));

  return { ...state, taskHistory: action.response, status };
};

const getUsersTaskHistoryFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-task-history-request', a));

  return { ...state, status };
};

const getUsersCommissionHistoryRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-users-commission-history-request');

  return { ...state, status };
};

const getUsersCommissionHistorySuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-commission-history-request', a));

  return { ...state, commissionHistory: action.response, status };
};

const getUsersCommissionHistoryFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-commission-history-request', a));

  return { ...state, status };
};

const getUsersActivityOverviewByIdRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-users-activity-overview-by-id-request');
  return { ...state, status };
};

const getUsersActivityOverviewByIdSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-activity-overview-by-id-request', a));

  return { ...state, userActivityStats: action.response, status };
};

const getUsersActivityOverviewByIdFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-activity-overview-by-id-request', a));

  return { ...state, status };
};

const getUsersByBranchRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-users-by-branch-request');

  return { ...state, status };
};

const getUsersByBranchSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-by-branch-request', a));

  return { ...state, usersByBranch: action.response.data, status };
};

const getUsersByBranchFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-by-branch-request', a));

  return { ...state, status };
};

const getUsersActivityPageRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-users-activity-page-request');

  return { ...state, status };
};

const clearActivityList = (state) => {
  const status = cloneDeep(state.status);
  status.push('clear-users-activity-page');

  return {
    ...state,
    overallUserActivity: null,
    overallUserActivityList: [],
    status,
  };
};

const getUsersActivityPageSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-activity-page-request', a));

  return { ...state, userActivityTypes: action.response.data, status };
};

const getUsersActivityPageFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-activity-page-request', a));

  return { ...state, status };
};

const getOverallUserActivityRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-overall-user-activity-${action.userId}`);

  return { ...state, status };
};

const getOverallUserActivitySuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-users-by-branch-request', a));

  return {
    ...state,
    overallUserActivity: action.response,
    overallUserActivityList: [...state.overallUserActivityList, ...action.response.data],
    status,
  };
};

const getOverallUserActivityFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-overall-user-activity-${action.userId}`, a));

  return { ...state, status };
};

const employeeFileListRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-employeeFileList-${action.userId}`);

  return { ...state, status };
};
const employeeFileListSuccess = (state, action) => {
  const users = cloneDeep(state.users);

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-employeeFileList-${action.response.id}`, a));

  return {
    ...state,
    users,
    employeeFileList: action.response.employeeFiles,
    status,
  };
};
const employeeFileListFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-employeeFileList-${action.userId}`, a));

  return { ...state, status };
};

const uploadEmpFileRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-uploadEmpFile-${action.userId}`);

  return { ...state, status };
};
const uploadEmpFileSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-uploadEmpFile-${action.response.id}`, a));
  return {
    ...state,
    employeeFileList: action.response.employeeFiles,
    status,
  };
};
const uploadEmpFileFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-uploadEmpFile-${action.userId}`, a));

  return { ...state, status };
};

const clearCreatedUserRequest = (state) => ({ ...state, createdUser: null });

const clearDisabledUserRequest = (state) => ({ ...state, disabledUser: null });

const clearActivatedUserRequest = (state) => ({
  ...state,
  activatedUser: null,
});

const clearHumanResourcesRequest = (state) => ({ ...state, ...initialState });

const setStatusUserLimitModalRequest = (state, action) => {
  const { isOpen } = action;

  return {
    ...state,
    userLimitModal: isOpen,
  };
};

export const reducer = createReducer(initialState, {
  [HumanResourcesTypes.CREATE_USER_SUCCESS]: createUserSuccess,
  [HumanResourcesTypes.CREATE_USER_FAILURE]: createUserFailure,

  [HumanResourcesTypes.GET_ALL_USER_STATS_SUCCESS]: getAllUserStatsSuccess,
  [HumanResourcesTypes.GET_ALL_USER_STATS_FAILURE]: getAllUserStatsFailure,

  [HumanResourcesTypes.GET_USERS_REQUEST]: getUsersRequest,
  [HumanResourcesTypes.GET_USERS_SUCCESS]: getUsersSuccess,
  [HumanResourcesTypes.GET_USERS_FAILURE]: getUsersFailure,
  [HumanResourcesTypes.CLEAR_SUCCESS_USERS_REQUEST]: clearSuccessUsersRequest,

  [HumanResourcesTypes.GET_USERS_INFRACTIONS_REQUEST]: getUsersInfractionsRequest,
  [HumanResourcesTypes.GET_USERS_INFRACTIONS_SUCCESS]: getUsersInfractionsSuccess,
  [HumanResourcesTypes.GET_USERS_INFRACTIONS_FAILURE]: getUsersInfractionsFailure,
  [HumanResourcesTypes.GET_USERS_ACTIVITIES_REQUEST]: getUsersActivitiesRequest,
  [HumanResourcesTypes.GET_USERS_ACTIVITIES_SUCCESS]: getUsersActivitiesSuccess,
  [HumanResourcesTypes.GET_USERS_ACTIVITIES_FAILURE]: getUsersActivitiesFailure,
  [HumanResourcesTypes.GET_USERS_TASK_HISTORY_REQUEST]: getUsersTaskHistoryRequest,
  [HumanResourcesTypes.GET_USERS_TASK_HISTORY_SUCCESS]: getUsersTaskHistorySuccess,
  [HumanResourcesTypes.GET_USERS_TASK_HISTORY_FAILURE]: getUsersTaskHistoryFailure,
  [HumanResourcesTypes.GET_USERS_COMMISSION_HISTORY_REQUEST]: getUsersCommissionHistoryRequest,
  [HumanResourcesTypes.GET_USERS_COMMISSION_HISTORY_SUCCESS]: getUsersCommissionHistorySuccess,
  [HumanResourcesTypes.GET_USERS_COMMISSION_HISTORY_FAILURE]: getUsersCommissionHistoryFailure,
  [HumanResourcesTypes.GET_USERS_ACTIVITY_OVERVIEW_BY_ID_REQUEST]: getUsersActivityOverviewByIdRequest,
  [HumanResourcesTypes.GET_USERS_ACTIVITY_OVERVIEW_BY_ID_SUCCESS]: getUsersActivityOverviewByIdSuccess,
  [HumanResourcesTypes.GET_USERS_ACTIVITY_OVERVIEW_BY_ID_FAILURE]: getUsersActivityOverviewByIdFailure,
  [HumanResourcesTypes.GET_USERS_BY_BRANCH_REQUEST]: getUsersByBranchRequest,
  [HumanResourcesTypes.GET_USERS_BY_BRANCH_SUCCESS]: getUsersByBranchSuccess,
  [HumanResourcesTypes.GET_USERS_BY_BRANCH_FAILURE]: getUsersByBranchFailure,
  [HumanResourcesTypes.CLEAR_ACTIVITY_LIST]: clearActivityList,
  [HumanResourcesTypes.GET_USERS_ACTIVITY_PAGE_REQUEST]: getUsersActivityPageRequest,
  [HumanResourcesTypes.GET_USERS_ACTIVITY_PAGE_SUCCESS]: getUsersActivityPageSuccess,
  [HumanResourcesTypes.GET_USERS_ACTIVITY_PAGE_FAILURE]: getUsersActivityPageFailure,

  [HumanResourcesTypes.GET_OVERALL_USER_ACTIVITY_REQUEST]: getOverallUserActivityRequest,
  [HumanResourcesTypes.GET_OVERALL_USER_ACTIVITY_SUCCESS]: getOverallUserActivitySuccess,
  [HumanResourcesTypes.GET_OVERALL_USER_ACTIVITY_FAILURE]: getOverallUserActivityFailure,

  [HumanResourcesTypes.EMPLOYEE_FILE_LIST_REQUEST]: employeeFileListRequest,
  [HumanResourcesTypes.EMPLOYEE_FILE_LIST_SUCCESS]: employeeFileListSuccess,
  [HumanResourcesTypes.EMPLOYEE_FILE_LIST_FAILURE]: employeeFileListFailure,

  [HumanResourcesTypes.UPLOAD_EMP_FILE_REQUEST]: uploadEmpFileRequest,
  [HumanResourcesTypes.UPLOAD_EMP_FILE_SUCCESS]: uploadEmpFileSuccess,
  [HumanResourcesTypes.UPLOAD_EMP_FILE_FAILURE]: uploadEmpFileFailure,

  [HumanResourcesTypes.CLEAR_CREATED_USER_REQUEST]: clearCreatedUserRequest,
  [HumanResourcesTypes.CLEAR_DISABLED_USER_REQUEST]: clearDisabledUserRequest,
  [HumanResourcesTypes.CLEAR_ACTIVATED_USER_REQUEST]: clearActivatedUserRequest,
  [HumanResourcesTypes.CLEAR_HUMAN_RESOURCES_REQUEST]: clearHumanResourcesRequest,
  [HumanResourcesTypes.SET_STATUS_USER_LIMIT_MODAL]: setStatusUserLimitModalRequest,
});
